import { render, staticRenderFns } from "./contactStaff.vue?vue&type=template&id=fd6ffc84&scoped=true"
import script from "./contactStaff.vue?vue&type=script&lang=js"
export * from "./contactStaff.vue?vue&type=script&lang=js"
import style0 from "./contactStaff.vue?vue&type=style&index=0&id=fd6ffc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6ffc84",
  null
  
)

export default component.exports